import React from 'react'
import styled from '@emotion/styled'
import { bool } from 'prop-types'

import { BackToTop } from '../svgs/BackToTop'

// Styled Components
export const BackToTopContainer = styled.div`
	bottom: ${({ hitFooter }) => (hitFooter ? 0 : '20px')};
	padding-top: 10px;
	position: ${({ hitFooter }) => (hitFooter ? 'absolute' : 'fixed')};

	svg,
	path,
	text {
		cursor: pointer;
		transition: all 0.3s ease;
	}

	:hover {
		path,
		text {
			fill: ${({ theme }) => theme.backToTop.hoverColor};
		}
	}
`

BackToTopSticky.propTypes = {
	hitFooter: bool,
	isSticky: bool,
}

export function BackToTopSticky(props) {
	const { isSticky, hitFooter } = props

	return (
		<BackToTopContainer isSticky={isSticky} hitFooter={hitFooter}>
			<BackToTop />
		</BackToTopContainer>
	)
}
